import React from "react";
import {
  InstanceParametersType,
} from "../../redux/api/api.types";
import InstanceContactRow from "./InstanceContactRow";
import InstanceContactTable from "./InstanceContactTable";

export default function InstanceContactDataTable (data: InstanceParametersType) {
  const renderContactTable = ({ django }: InstanceParametersType) => {
    const {cuemail, cufirstname, culastname} = django;
    return InstanceContactRow({
      rowEmail: cuemail || "-",
      rowFirst: cufirstname || "-",
      rowLast: culastname || "-"
    })
  }
  return (
    <InstanceContactTable
      title="Contact"
      headers={
        InstanceContactRow({
          rowEmail: "Email",
          rowFirst: "First Name",
          rowLast: "Last Name"
        }, true)
      }
      tableData={renderContactTable(data)}
    />
  );
}